import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M72.948 35c.058 1.103-.853 2-1.957 2H2.008C.904 37-.006 36.103.052 35 1.077 15.496 17.003 0 36.5 0s35.423 15.496 36.448 35z",
  fill: "#C1E5FF"
});

var _ref2 =
/*#__PURE__*/
___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.047 13.376c.548-.997-.729-1.99-1.56-1.212L32.369 30.058a6.314 6.314 0 1 0 8.058 6.277l12.621-22.959z",
  fill: "#73C4FF"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 73,
    height: 43,
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/faq-risk.5c2db383.svg";
export { SvgComponent as ReactComponent };